export const listOfSections = {
    isUnderGraduate: "isUnderGraduate",
    qualificationNote: "qualificationNote",
    lookingForNote: "lookingForNote",
    underGraduateDegree: "underGraduateDegree",
    aadharOrIdProof: "aadharOrIdProof",
    legalPhoto: "legalPhoto",
    marksheetOrDegreeCert: "marksheetOrDegreeCert",
    marksheetOrDegreeCertCrop: "marksheetOrDegreeCertCrop",
    fullName: "fullName",
    allInfoPage: "allInfoPage",
    marksheetStatus: "marksheetStatus",
    fullNameStatus: "fullNameStatus",
    aadharStatus: "aadharStatus",
    qualificationStatus: "qualificationStatus",
    passportPhotoStatus: "passportPhotoStatus",
} as const


export const idVerificationProofStatus = {
    unVerified: "unVerified",
    inProgress: "inProgress",
    verified: "verified",
    rejected: "rejected",
} as const;